import doRequest from "./index";

const GlobalService = {
  // a function to get user menus list
  getUserTables: () => {
    return doRequest(
      "get",
      `https://stokercloud.dk/json/indexstats.php`
    );
  },
  getUserLocations: () => {
    return doRequest(
      "get",
       `https://www.stokercloud.dk/json/mapusersjson2.php`
      //"http://www.stokercloud.dk/mapusers.php"
    );
  },
  getUserInfo: (userId) => {
    return doRequest(
      "get",
      `https://www.stokercloud.dk/json/viewuserdata.php?userid=${userId}`
    );
  },
  searchUsers: (keys) => {
    return doRequest(
      "get",
      `https://www.stokercloud.dk/json/searchsuggest.php?search=${keys}`
    );
  },
};

export default GlobalService;
